import { useCallback } from "react";

import { useSiteControllerSettingAirHostMutation } from "../../repository";
import { viewModelToInput } from "./converter/view-model-to-input";

import type { SiteControllerSettingAirHostFormModel } from "../../type";

type Props = {
	viewModel: SiteControllerSettingAirHostFormModel["ViewModel"]; //
};

export const useSiteControllerSettingAirHost = ({ viewModel }: Props) => {
	const { onUpdate: _onUpdate } = useSiteControllerSettingAirHostMutation();
	const onUpdate = useCallback(async () => {
		const input = viewModelToInput({ viewModel });
		return await _onUpdate({ input });
	}, [_onUpdate, viewModel]);

	return { onUpdate };
};
